import { useEffect } from 'preact/hooks';

/**
 * When the user change the orientation it triggers the callback
 * @param {Function} callback
 */
export const useChangeOrientation = (callback) => {
  useEffect(() => {
    const portrait = window.matchMedia('(orientation: portrait)');

    portrait.addEventListener('change', (e) => {
      callback();
      if (e.matches) {
        // Here do sth only on portrait mode
      } else {
        // Here do sth only on landscape mode
      }
    });
  }, []);
};
